/**
 * Short "Did you know?" facts shown on the grass-ID analyzing screen, mirroring
 * the labor-perception beat the mobile app's BuildingPlanOverlay uses. Grass
 * type isn't known yet during identification, so these are general lawn-care
 * truths that read as expert context while the vision call runs.
 *
 * Style: conversational, no em-dashes (writing convention).
 */
export const ANALYZING_FACTS: string[] = [
  "Most lawn problems trace back to mowing too short, not to pests.",
  "Grass does most of its work below ground, growing roots before you see top growth.",
  "Watering deeply twice a week beats a light sprinkle every day.",
  "A sharp mower blade cuts clean; a dull one tears and invites disease.",
  "Morning is the best time to water, so the blades dry before nightfall.",
  "The right grass for your region stays green with far less work.",
  "Feeding grass during its active growth window does more with less fertilizer.",
  "Leaving clippings on the lawn returns nitrogen and cuts your fertilizer needs.",
]

/** Pick a fact deterministically from a seed (e.g. a mount-time random index). */
export function getAnalyzingFact(index: number): string {
  return ANALYZING_FACTS[index % ANALYZING_FACTS.length]
}
